import React, { useState } from 'react';
import { Table, Button, Input, Space, Card, Tag, Typography } from 'antd';
import { UserOutlined, SearchOutlined, EditOutlined, UserAddOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getUsers, type UserDto } from '../../api/users';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

const UsersList: React.FC = () => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    const { data: pagedResult, isLoading } = useQuery({
        queryKey: ['adminUsers', page, pageSize, search],
        queryFn: () => getUsers({ page, pageSize, search }),
    });

    const columns = [
        {
            title: 'Ad Soyad',
            key: 'name',
            render: (record: UserDto) => (
                <Space>
                    <UserOutlined />
                    <Text strong>{record.firstName} {record.lastName}</Text>
                </Space>
            ),
        },
        {
            title: 'E-posta',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Rol',
            dataIndex: 'role',
            key: 'role',
            render: (role: string) => {
                let color = 'blue';
                if (role === 'SuperAdmin') color = 'volcano';
                if (role === 'Admin') color = 'green';
                return <Tag color={color}>{role.toUpperCase()}</Tag>;
            },
        },
        {
            title: 'Kayıt Tarihi',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (date: string) => dayjs(date).format('DD.MM.YYYY HH:mm'),
        },
        {
            title: 'İşlemler',
            key: 'actions',
            render: (record: UserDto) => (
                <Space>
                    <Button 
                        type="primary" 
                        icon={<EditOutlined />} 
                        onClick={() => navigate(`/admin/users/${record.id}`)}
                    >
                        Düzenle
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-6">
                <Title level={2}>Kullanıcı Yönetimi</Title>
                <Button 
                    type="primary" 
                    icon={<UserAddOutlined />} 
                    size="large"
                    onClick={() => navigate('/admin/users/create')}
                >
                    Yeni Kullanıcı Ekle
                </Button>
            </div>

            <Card className="shadow-sm">
                <div className="mb-4">
                    <Input
                        placeholder="Kullanıcı ara (Ad, Soyad, E-posta...)"
                        prefix={<SearchOutlined />}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ width: 300 }}
                        allowClear
                    />
                </div>

                <Table
                    columns={columns}
                    dataSource={pagedResult?.data || []}
                    rowKey="id"
                    loading={isLoading}
                    pagination={{
                        current: page,
                        pageSize: pageSize,
                        total: pagedResult?.totalRecords || 0,
                        onChange: (p, s) => {
                            setPage(p);
                            setPageSize(s);
                        },
                        showSizeChanger: true,
                    }}
                />
            </Card>
        </div>
    );
};

export default UsersList;
